import CacheEnum from '@/enums/cacheEnum';
import PageEnum from '@/enums/pageEnum';
import { useLocalStorage } from '@/hooks/useStorage';
import { getCardValueApi, getMenuListApi } from '@/services/api/requestApi';
import { useReq } from '@/services/net/request';
import ProjectSetting from '@/setting/projectSetting';
import { history } from '@umijs/max';
import { useFavicon, useMount } from 'ahooks';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * 使用自定义hook获取应用信息并存储到localStorage中。
 * 该hook不接受任何参数。
 *
 * @returns {Object} 返回一个包含appInfo的对象。
 */
export default () => {
  const { t } = useTranslation();

  // query-value  query-value query-value
  const { data: appInfo = {} } = useReq(getCardValueApi, {
    onSuccess(data) {
      // 成功获取数据后，将数据存储到localStorage的APP_BASE_INFO键中
      document.title = data?.APP_BASE_NAME;
      localStorage.setItem(CacheEnum.APP_BASE_INFO, JSON.stringify(data));
    },
  }) as any;

  // 获取本地可使用的菜单列表
  const { data: menuList, run: getMenuListReq } = useReq(getMenuListApi, {
    manual: true,
  }) as any;
  useFavicon((appInfo as any)?.APP_BASE_ICON);
  //  获取菜单列表
  useMount(() => {
    getMenuListReq();
  });
  useEffect(() => {
    if(appInfo?.APP_BASE_LOGO){
      const metaTag = document.createElement('meta');
      metaTag.setAttribute('property', 'og:image');
      metaTag.setAttribute('content', appInfo?.APP_BASE_LOGO);
      document.head.appendChild(metaTag);
    }
  }, [appInfo?.APP_BASE_LOGO]);


  // 筛选出可见的菜单
  const getShowMenuList = (list: any) => {
    if (!menuList) return [];
    return list?.filter((item: any) => {
      let findMenuItem: any;
      if (Array.isArray(menuList)) {
        findMenuItem = menuList?.find(
          (menu: any) => menu?.path === item?.path && item?.visible !== 0,
        );
      }
      if (!findMenuItem) {
        return true;
      } else {
        return findMenuItem.visible === 1;
      }
    });
  };

  // 第三方股票名称拼接---为了国际化插件能扫描到做的方法
  const getThirdStockName = () => {
    if (ProjectSetting.APP_STOCK_SYMBOL === 'INR') return t('印度股票');
    if (ProjectSetting.APP_STOCK_SYMBOL === 'BRL') return t('巴西股票');
    if (ProjectSetting.APP_STOCK_SYMBOL === 'NT$') return t('當沖');
  };
  const { CUSTOMER_SERVICE_LIST = {} } = appInfo;

  const [, setImParmaData]: any = useLocalStorage({
    key: CacheEnum.APP_IM_DATA,
    defaultValue: [],
  });

  // 跳转客服
  const goService = () => {
    // 外联三方客服
    if (
      !['', null, undefined].includes(appInfo?.EXTERNAL_CUSTOMER_SERVICE_URL)
    ) {
      if (window?.ssq) {
        return ssq.push('chatOpen');
      }
    } else {
      // 使用我们的客服
      setImParmaData(undefined);
      history.push(PageEnum.ONLINESUPPORT);
    }
  };
  // 发送信息给客服
  const sendMsg = (msg: string = '') => {
    // 外联三方客服
    if (
      !['', null, undefined].includes(appInfo?.EXTERNAL_CUSTOMER_SERVICE_URL)
    ) {
      if (window?.ssq) {
        return ssq.push('sendTextMessage', `${msg}`);
      }else{
        window.open(appInfo?.EXTERNAL_CUSTOMER_SERVICE_URL);
      }
    } else {
      // 使用我们的客服
      setImParmaData({ msg });
      history.push(PageEnum.ONLINESUPPORT, {
        msg,
      });
    }
  };

  // jpy 兑换usd的汇率
  const jpyUsdRate = useMemo(
    () => appInfo?.EXCHANGE_UDS_JPY_NUM ?? 155,
    [appInfo],
  );

  return {
    appInfo, // 返回获取到的应用信息
    menuList,
    getShowMenuList,
    getThirdStockName,
    goService,
    sendMsg,
    jpyUsdRate,
  };
};
